export const SOFTPULL_MODULE = 'SoftPullModule';
